import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=183c94bb&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=ts&"
export * from "./Posts.vue?vue&type=script&lang=ts&"
import style0 from "./Posts.vue?vue&type=style&index=0&id=183c94bb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183c94bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
